import { axiosRequest } from "../../configs/axios.config";

export class LandingConfigurationService {
  getSingleRecord(organization_token, tenantId, success, error) {
    const url = !!!tenantId
      ? `/landing_configurations/${organization_token}`
      : `/tenants/${tenantId}/landing_configurations/${organization_token}`;

    axiosRequest
      .get(url)
      .then((data) => success(data))
      .catch((err) => error(err));
  }

  updateRecord(idConfiguration, dataParams, success, error) {
    axiosRequest
      .put(`/landing_configurations/${idConfiguration}`, dataParams)
      .then((data) => success(data))
      .catch((err) => error(err));
  }
}
